import type { ETermType, ResponseGetTerms } from "@schemas/terms";

import instance from "@utils/axiosInstance";
import { useCreateQuery, type QueryOpts } from "@utils/generateReactQuery";

const BASE_URL = "/terms";

const API = {
	getList: async (termTypes: ETermType[]) =>
		await instance.get(BASE_URL, { params: { termTypes } }),
};

const KEY = {
	getList: (termTypes: ETermType[]) => [BASE_URL, termTypes],
};

export function useGetTerms(termTypes: ETermType[], options?: QueryOpts<ResponseGetTerms>) {
	return useCreateQuery<ResponseGetTerms>(KEY.getList(termTypes), () => API.getList(termTypes), {
		...options,
	});
}
